module.exports = __webpack_public_path__ + "img/header.80f8c10b.jpg";